import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import {
    getEmptyAvatarProfessionnel,
    getPictureFromProfilImage,
} from "../../utils/FormatUtils";
import { ItemValidated } from "../../cards/WorkerCard";
import { ProfessionnelInterestedByStructure } from "../../structures/model/StructureModel";
import { StructureInterestedByProfessionnel } from "../../professionnels/model/ProfessionnelModel";
import { useTranslation } from "react-i18next";

interface SmartAcceptedCardProps {
    Professionnel?: ProfessionnelInterestedByStructure["Professionnel"];
    Structure?: StructureInterestedByProfessionnel["Structure"];
    status: string;
}

export const SmartAcceptedCard: React.FC<SmartAcceptedCardProps> = (props) => {
    const { Professionnel, Structure, status } = props;

    const { i18n } = useTranslation();

    return (
        <Grid item xs={12} md={6}>
            <Card sx={{ display: "flex" }}>
                <CardContent sx={{ flex: 1 }}>
                    {Professionnel && (
                        <>
                            <Typography>
                                {Professionnel.prenom} {Professionnel.nom}
                            </Typography>
                            {Professionnel.profession.map(
                                ({ translations, name }, i) => (
                                    <Typography variant="subtitle1" key={i}>
                                        {translations?.[i18n.language] ?? name}
                                    </Typography>
                                )
                            )}
                            <Typography variant="subtitle1" color="primary">
                                {Professionnel.telephone}
                            </Typography>
                        </>
                    )}

                    {Structure && (
                        <>
                            <Typography>{Structure.societe}</Typography>
                            <Typography color="text.secondary">
                                {Structure.ville}
                            </Typography>
                            <Typography variant="subtitle1" color="primary">
                                {Structure.telephone}
                            </Typography>
                        </>
                    )}
                </CardContent>

                <CardMedia
                    component="img"
                    sx={{
                        width: 100,
                        display: { xs: "none", sm: "block" },
                    }}
                    image={
                        Professionnel?.profileImage
                            ? getPictureFromProfilImage(
                                  Professionnel.profileImage.contentUrl
                              )
                            : getEmptyAvatarProfessionnel()
                    }
                    alt={"profileImage Smart Sante"}
                />
            </Card>
        </Grid>
    );
};
